import * as types from '../actions/actionTypes';
import { assign } from 'lodash';

const initialState = {
  data: {
    seoName: '',
    seoTitle: '',
    seoDescription: '',
    clientLogo: '',
    heroImg: '',
    showNavbar: true,
    showHero: true,
    showFooter: true,
    theme: 'default',
    layout: 'default',
  },
};

function settings(state = initialState, action) {
  switch (action.type) {
    case types.SETTINGS_FETCH_ERROR:
    case types.SETTINGS_EDIT_ERROR:
      return assign({}, state, {
        error: action.res,
      });
    case types.SETTINGS_FETCH_SUCCESS:
    case types.SETTINGS_EDIT_SUCCESS:
      return assign({}, state, {
        data: action.res }
      );
    case types.SETTINGS_CLEAR_ERRORS:
      return assign({}, state, {
        error: false,
      });
    default:
      return state;
  }
}

export default settings;



// WEBPACK FOOTER //
// ./src/reducers/settings.js